import { render, staticRenderFns } from "./AddPopup.vue?vue&type=template&id=4d8099c0&scoped=true"
import script from "./AddPopup.vue?vue&type=script&lang=js"
export * from "./AddPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8099c0",
  null
  
)

export default component.exports